import { render } from "./pot-position-salary.vue?vue&type=template&id=67b30be0"
import script from "./pot-position-salary.vue?vue&type=script&lang=js"
export * from "./pot-position-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/pot/pot-position-salary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67b30be0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67b30be0', __exports__)) {
    api.reload('67b30be0', __exports__)
  }
  
  module.hot.accept("./pot-position-salary.vue?vue&type=template&id=67b30be0", () => {
    api.rerender('67b30be0', render)
  })

}


export default __exports__